<template>
  <div>
    <Header />

    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />
    <confirmPopup
      v-if="popupwindow == true"
      :title="titlepass"
      @cancelClick="popupwindow = false"
      @confirmClick="deletecourse(idpass)"
    />

    <div class="py-3">
      <div class="container mx-auto max-w-[1200px] px-6 md:px-0">
        <div
          class="flex flex-col-reverse lg:flex-row justify-between items-center gap-8 rounded-3xl shadow-xl my-10 h-full"
        >
          <div
            class="lg:px-20 flex flex-col py-10 gap-6 justify-between h-full text-center lg:text-left px-6"
          >
            <h1
              class="font-bold text-xl lg:text-3xl prime"
              v-if="this.userInfo"
            >
              Welcome
              <span v-if="this.userInfo?.user?.display_name">
                {{ this.userInfo?.user?.display_name }}
              </span>
              <span v-else>{{ this.userInfo?.user?.permission }}</span>

              <span
                class="text-[#105C8E] text-xl lg:text-3xl ml-2 lg:ml-5"
              ></span>
            </h1>

            <p class="content max-w-sm">
              Looking for information about {{ logotitle }} itself (features,
              use cases, or documentation). Referring to reusing or duplicating
              organizing content for it.
            </p>

            <!-- <form @submit.prevent="searchUserValue" class="w-full">
              <div
                class="flex flex-wrap md:flex-nowrap items-center justify-center lg:justify-start gap-4"
              >
                <input
                  type="text"
                  v-model="search_title"
                  @input="searchUserValue"
                  placeholder="Search The Course"
                  class="rounded-full px-6 py-3 border w-full lg:w-auto"
                />
                <button
                  type="submit"
                  class="bg-primary py-3 rounded-2xl text-white px-6"
                >
                  Search
                </button>
              </div>
            </form> -->
            <SearchView />
          </div>

          <div class="flex justify-center lg:justify-end w-full lg:w-auto">
            <img
              src="@/assets/new/boy.png"
              alt=""
              class="w-full lg:w-auto h-auto rounded-r-3xl object-contain max-h-[400px]"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="pt-0 pb-20">
      <div class="container mx-auto max-w-[1200px] flex flex-col gap-10 px-6">
        <div class="flex items-center justify-between">
          <h1 class="text-xl font-bold text-primary">Your Recent Courses</h1>

          <router-link :to="{ name: 'AdminCoursess' }"> View All </router-link>
        </div>

        <div v-if="loading" class="flex items-center justify-center">
          <img src="@/assets/newd/loading.gif" alt="" />
        </div>
        <div v-else>
          <div v-if="courselist.length > 0" class="grid lg:grid-cols-3 gap-10">
            <div
              class="rounded-3xl"
              v-for="course in this.courselist.slice(0, 3)"
              :key="course"
              style="box-shadow: 0px 2px 20px 0px #105c8e26"
            >
              <div
                class="flex flex-col min-h-[400px] justify-between lg:text-left p-8"
              >
                <img
                  v-if="course.thumbnail"
                  class="object-cover object-center h-[200px] w-full rounded-lg"
                  :src="course.thumbnail"
                  alt=""
                />
                <img
                  v-else
                  class="object-cover object-center h-24 w-52 rounded"
                  src="@/assets/coding.svg"
                  alt=""
                />
                <router-link
                  :to="{
                    name: 'InstructorStudents',
                    params: {
                      course_id: course.id,
                      department_id: course.department.id,
                    },
                  }"
                  class="flex flex-col gap-1"
                >
                  <h1 class="font-bold text-lg text-primary py-2">
                    {{ course.title.slice(0, 50) }}
                    <p
                      v-if="course.title.length > 50"
                      class="text-primary text-sm mt-1 font-semibold"
                    >
                      ...More
                    </p>
                  </h1>
                  <!-- <p class="text-secondary">
                    {{ course.sections.length }} Units
                  </p> -->

                  <div class="flex flex-col gap-1">
                    <p class="text-sm">
                      <span class="font-semibold">Course Code:</span>
                      {{ course?.course_code || "NAN" }}
                    </p>

                    <p class="text-sm">
                      <span class="font-semibold">Program:</span>
                      {{ course?.program?.name || "NAN" }}
                    </p>
                    <p class="text-sm">
                      <span class="font-semibold">Department: </span
                      >{{ course?.department?.name || "NAN" }}
                    </p>
                    <p class="text-sm">
                      <span class="font-semibold">Semester: </span
                      >{{ course?.semester?.semester || "NAN" }}
                    </p>
                    <p class="text-sm">
                      <span class="font-semibold">Instructor Email:</span>
                      <span v-if="course.instructor.length > 0">
                        {{ course?.instructor[0].user.email }}
                      </span>
                      <span v-else>NAN</span>
                    </p>
                    <p class="text-sm">
                      <span class="font-semibold">Section:</span>
                      {{ course?.class_section || "NAN" }}
                    </p>
                    <p class="text-sm">
                      <span class="font-semibold">Course Type:</span>
                      {{ course?.course_type?.title || "NAN" }}
                    </p>
                    <p class="text-sm">
                      <span class="font-semibold">Instructor Name:</span>
                      <span v-if="course.instructor.length > 0">
                        {{ course.instructor[0].user.display_name }}
                      </span>
                      <span v-else>NAN</span>
                    </p>
                  </div>
                </router-link>

                <div class="flex items-center gap-10 mt-5">
                  <!-- <div @click="editCoursePopup = true; currentId = course.id">
                    <img src="@/assets/newd/icon2.svg" alt="Edit Course" />
                  </div> -->

                  <!-- <div
                    @click="
                      addLessonUnitPopup = true;
                      currentId = course.id;
                    "
                  >
                    <img src="@/assets/newd/icon1.svg" alt="Add Course" class=" cursor-pointer" />
                  </div> -->

                  <!-- AddLessonUnit -->

                  <router-link
                    :to="{
                      name: 'AddLessonUnit',
                      params: { course_id: course.id },
                    }"
                    class="flex flex-col gap-1"
                  >
                    <div>
                      <img
                        src="@/assets/newd/icon1.svg"
                        alt="Add Course"
                        class="cursor-pointer"
                      />
                    </div>
                  </router-link>

                  <router-link
                    v-if="
                      this.userInfo?.user?.permission == 'super_admin' ||
                      this.userInfo?.user?.permission == 'hod' ||
                      this.userInfo?.user?.permission == 'co-ordinator'
                    "
                    :to="{
                      name: 'InstructorCourseEdit',
                      params: { course_id: course.id },
                    }"
                    class="flex flex-col gap-1"
                  >
                    <div>
                      <img src="@/assets/newd/icon2.svg" alt="Edit Course" />
                    </div>
                  </router-link>

                  <div
                    @click="
                      titlepass = course.title;
                      popupwindow = true;
                      idpass = course.id;
                    "
                    class="cursor-pointer"
                    v-if="
                      this.userInfo?.user?.permission == 'super_admin' ||
                      this.userInfo?.user?.permission == 'hod' ||
                      this.userInfo?.user?.permission == 'co-ordinator'
                    "
                  >
                    <img src="@/assets/newd/icon3.svg" alt="Delete Course" />
                  </div>

                  <router-link
                    :to="{
                      name: 'AdminCoursePreview',
                      params: { course_id: course.id },
                    }"
                    class="cursor-pointer bg-blues text-white px-3 py-1 text-sm font-bold rounded-2xl transition-colors duration-200 hover:bg-blue-100 hover:text-black hover:border-blues border border-transparent"
                  >
                    Preview
                  </router-link>

                  <!-- <router-link
                    :to="{
                      name: 'AdminCoursePreview',
                      params: { course_id: course.id },
                    }"
                    class="cursor-pointer bg-blues text-white px-3 py-1 text-sm font-bold rounded-2xl transition-colors duration-200 hover:bg-blue-100 hover:text-black hover:border-blues border border-transparent"
                  >
                    C
                  </router-link> -->
                </div>
              </div>
            </div>
          </div>
          <div v-else class="text-lg font-normal text-center">
            No data Found
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Instructor/Header.vue";
import Footer from "@/components/Footer.vue";

import axios from "axios";
import { mapGetters } from "vuex";

import ConfirmPopup from "@/components/ConfirmPopup.vue";
import FlashMessage from "@/components/FlashMessage.vue";
import SearchView from "@/components/SearchView.vue";

export default {
  components: {
    Header,
    Footer,
    ConfirmPopup,
    FlashMessage,
    SearchView,
  },

  data() {
    return {
      logotitle: process.env.VUE_APP_TITLE,
      courselist: "",
      instructorInfo: "",
      messages: "",
      popupwindow: false,
      loading: true,
      search_title: "",
    };
  },

  computed: mapGetters(["userInfo"]),

  async created() {
    await axios
      .get(
        `${process.env.VUE_APP_API}/instructor/?Key=${this.userInfo.token_key}`
      )
      .then((response) => {
        this.instructorInfo = response.data;
        console.log(this.instructorInfo, "info");
      });
    await axios
      .get(`${process.env.VUE_APP_API}/courses/?Key=${this.userInfo.token_key}`)
      .then((response) => {
        if (response.data.status == 200) {
          this.courselist = response.data.data.data.data;
        }
        // if (
        //   response.data &&
        //   response.data.data &&
        //   response.data.data.length > 0
        // ) {
        //   this.courselist = response.data.data;
        // }
      })
      .catch((err) => {
        console.log("error", err);
      })
      .finally(() => {
        setTimeout(() => {
          this.loading = false;
        }, 600);
      });
  },
  // mounted() {
  //   setTimeout(() => {
  //     this.loading = false;
  //   }, 2000);
  // },
  methods: {
    async deletecourse(data) {
      await axios
        .delete(
          `${process.env.VUE_APP_API}/courseupdate/${data}/?Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          this.res = response;
          if (this.res.statusText == "No Content") {
            this.messages = {
              text: "Deleted successfully",
              type: "success",
            };
            console.log("successfull");
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
          }
        });
      this.popupwindow = false;

      setTimeout(() => {
        this.$router.go(0);
        this.messages = {
          text: "",
          type: "null",
        };
      }, 2000);
    },
    async searchUserValue() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/courses/?title=${this.search_title}&Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          if (response.data.message == "No courses details") {
            console.log("Null");
          } else {
            this.courselist = response.data.data;
            this.courselist.forEach((element) => {
              element.displayprice = new Intl.NumberFormat("hi-IN", {
                style: "currency",
                currency: "INR",
                maximumFractionDigits: 0,
              }).format(element.price);
            });
          }
        });
    },
  },
};
</script>

<style></style>
